import { render, staticRenderFns } from "./tableReportVDP.vue?vue&type=template&id=089a1d18&scoped=true"
import script from "./tableReportVDP.vue?vue&type=script&lang=js"
export * from "./tableReportVDP.vue?vue&type=script&lang=js"
import style0 from "./tableReportVDP.vue?vue&type=style&index=0&id=089a1d18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089a1d18",
  null
  
)

export default component.exports